import { render } from "./AchievementStateConfirmation.vue?vue&type=template&id=273c23d0&scoped=true&ts=true"
import script from "./AchievementStateConfirmation.vue?vue&type=script&lang=ts"
export * from "./AchievementStateConfirmation.vue?vue&type=script&lang=ts"

import "./AchievementStateConfirmation.vue?vue&type=style&index=0&id=273c23d0&lang=scss&scoped=true"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273c23d0"]])

export default __exports__